import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<header class=\"py-10 relative\"><div class=\"max-w-7xl mx-auto\" style=\"z-index:2;\"><h1 class=\"text-3xl font-bold text-white\">Welcome to your loan dashboard!</h1><p class=\"text-sm text-white max-w-3xl mt-1\">You can process any type of multifamily, commercial property or small business loan through Janover Ventures, right here! Below you will see open deals you are working on, that you can edit in real time. Once you submit a loan; our system will quickly and automatically work to match you with the right lender. Good luck!</p></div><div class=\"bg-sky absolute w-screen h-20 top-full -mt-2 left-1/2\" style=\"transform:translateX(-50%);\"></div></header>", 1)
const _hoisted_2 = {
  class: "grid grid-cols-9 gap-4 relative",
  style: {"z-index":"3"}
}
const _hoisted_3 = { class: "bg-white shadow-sm rounded-lg col-span-6 divide-y" }
const _hoisted_4 = { class: "px-6 py-4 flex items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl leading-8 font-bold" }, "Loan requests", -1)
const _hoisted_6 = { class: "w-2/3" }
const _hoisted_7 = { class: "text-sm leading-5 font-medium text-sky mb-2" }
const _hoisted_8 = { class: "text-sm leading-5 font-normal text-gray-500 flex items-center" }
const _hoisted_9 = { class: "w-1/3 flex flex-col items-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mx-1" }, "|", -1)
const _hoisted_11 = { class: "bg-white shadow-sm rounded-lg col-span-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl leading-8 font-bold" }, "Notifications")
], -1)
const _hoisted_13 = { class: "flow-root pl-6 pr-8 pt-4" }
const _hoisted_14 = {
  role: "list",
  class: "-mb-8"
}
const _hoisted_15 = { class: "relative pb-8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_17 = { class: "relative flex space-x-3" }
const _hoisted_18 = { class: "h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center ring-8 ring-white" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-700" }, "Lender"),
      /*#__PURE__*/_createTextVNode(" provided a quote on "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-sky font-medium" }, "$2M Office Refinance, TX"),
      /*#__PURE__*/_createTextVNode(" 2d ago ")
    ])
  ])
], -1)
const _hoisted_20 = { class: "relative pb-8" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_22 = { class: "relative flex space-x-3" }
const _hoisted_23 = { class: "h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center ring-8 ring-white" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-700" }, "Lender"),
      /*#__PURE__*/_createTextVNode(" provided a quote on "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-sky font-medium" }, "$2M Office Refinance, TX"),
      /*#__PURE__*/_createTextVNode(" 2d ago ")
    ])
  ])
], -1)
const _hoisted_25 = { class: "relative pb-8" }
const _hoisted_26 = { class: "relative flex space-x-3" }
const _hoisted_27 = { class: "h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center ring-8 ring-white" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-700" }, "You"),
      /*#__PURE__*/_createTextVNode(" updated a "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-sky font-medium" }, "$2M Office Refinance, TX"),
      /*#__PURE__*/_createTextVNode(" request 3d ago ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LocationMarkerIcon = _resolveComponent("LocationMarkerIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_TicketIcon = _resolveComponent("TicketIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_router_link, {
            to: "/borrower-deal?newDeal=true",
            class: "bg-sky text-white rounded-md px-3 py-2 text-sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode("New request")
            ]),
            _: 1
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deals, ({ name, address, status, time, color, query }, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "py-4 px-6 flex justify-between items-center",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(name), 1),
              _createElementVNode("p", _hoisted_8, [
                _createVNode(_component_LocationMarkerIcon, { class: "w-4 h-4 mr-1" }),
                _createTextVNode(" " + _toDisplayString(address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["py-1 px-3 flex justify-center items-center text-xs rounded-full", {
              'bg-yellow-200 text-yellow-700': color == 'yellow',
              'bg-gray-100 text-gray-700': color == 'gray',
              'bg-green-100 text-green-700': color == 'green'
            }])
              }, [
                _createElementVNode("span", null, _toDisplayString(time), 1),
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(status), 1)
              ], 2),
              _createVNode(_component_router_link, {
                to: { name: 'borrower-deal', query },
                class: "inline-flex items-center leading-5 font-medium text-sky text-xs mt-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Open details "),
                  _createVNode(_component_ArrowRightIcon, { class: "w-4 h-3 ml-1" })
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_TicketIcon, { class: "w-5 h-5 text-gray-500" })
                    ])
                  ]),
                  _hoisted_19
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_TicketIcon, { class: "w-5 h-5 text-gray-500" })
                    ])
                  ]),
                  _hoisted_24
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_27, [
                      _createVNode(_component_TicketIcon, { class: "w-5 h-5 text-gray-500" })
                    ])
                  ]),
                  _hoisted_28
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}